import type { PreviewCardProps } from './types'

import { emotionTheme } from '@styles/theme'

import * as S from './styles'

export const PreviewCard = ({
  label,
  value,
  percentageValue,
  icon,
  bottomText,
  infoIcon,
  isBudget,
  inverted = false,
  borderColor,
  deviationState
}: PreviewCardProps) => {
  const isNegative = value.startsWith('-')
  // deviationState manda na cor quando informado: o sinal do valor vindo da API pode
  // divergir da comparação Prévia x Budget, e aí cor e texto ficariam contraditórios
  const invertedValue = deviationState ? deviationState === 'above' : inverted ? !isNegative : isNegative

  return (
    <S.Container style={{ borderTopColor: borderColor }}>
      <S.LeftBox>
        <S.Label>
          {label}
          {!!infoIcon && infoIcon}
        </S.Label>

        <S.PercentageValue
          style={{
            color: isBudget
              ? emotionTheme.colors.secondary
              : invertedValue
                ? emotionTheme.colors.error.color
                : emotionTheme.colors.success.color
          }}
        >
          {value}
        </S.PercentageValue>

        <S.Value
          style={{
            color: isBudget
              ? emotionTheme.colors.secondary
              : invertedValue
                ? emotionTheme.colors.error.color
                : emotionTheme.colors.success.color
          }}
        >
          {percentageValue}
        </S.Value>

        <S.BottomText>{bottomText}</S.BottomText>
      </S.LeftBox>

      <S.IconBox
        style={{
          color: isBudget
            ? emotionTheme.colors.primary
            : invertedValue
              ? emotionTheme.colors.error.color
              : emotionTheme.colors.success.color,
          background: isBudget
            ? emotionTheme.colors.gray.light
            : invertedValue
              ? emotionTheme.colors.error.background
              : emotionTheme.colors.success.background
        }}
      >
        {icon}
      </S.IconBox>
    </S.Container>
  )
}
